import styled from 'styled-components';

export const SCEcommerceNewPlan = styled.div`
  hr {
    border-style: solid;
    border-bottom: none;
    border-color: ${(props) => props.theme.colours.grey.altlight};
    margin: 1px;
  }

  .buttons {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    gap: 1rem;
  }

  .search-error {
    height: 1px;
    padding: 0;
    margin-top: 2em;
  }

  .flex {
    display: flex;
  }

  .flex-col {
    flex-direction: column;
  }

  .gap-6 {
    gap: 1.5rem;
  }

  .gap-8 {
    gap: 2rem;
  }
`;
